/**
 * Workshop Booking — geo / coordinate math (pure).
 * Single responsibility: numbers and distances. No DOM, no fetch, no shop state.
 */
(function (global) {
  if (global.WorkshopBookingGeo) return;

  function toNum(val) {
    if (val == null) return null;
    if (typeof val === 'string') {
      var s = val.trim();
      if (!s) return null;
      s = s.replace(/,/g, '');
      val = s;
    }
    var n = Number(val);
    return Number.isFinite(n) ? n : null;
  }

  function isValidCoord(lat, lng) {
    if (lat == null || lng == null) return false;
    if (lat === 0 && lng === 0) return false;
    if (Math.abs(lat) > 90 || Math.abs(lng) > 180) return false;
    return true;
  }

  function haversineKm(lat1, lon1, lat2, lon2) {
    var toRad = function (d) { return (d * Math.PI) / 180; };
    var R = 6371;
    var dLat = toRad(lat2 - lat1);
    var dLon = toRad(lon2 - lon1);
    var a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(toRad(lat1)) *
      Math.cos(toRad(lat2)) *
      Math.sin(dLon / 2) * Math.sin(dLon / 2);
    return 2 * R * Math.asin(Math.sqrt(a));
  }

  function parseCoord(v) {
    if (v == null) return null;
    if (typeof v === 'string') { v = v.trim(); if (v === '') return null; }
    var n = Number(v);
    return Number.isFinite(n) ? n : null;
  }

  function firstCoord() {
    for (var i = 0; i < arguments.length; i++) {
      var n = parseCoord(arguments[i]);
      if (n != null) return n;
    }
    return null;
  }

  /** Haversine with clamped asin (distance display). */
  function haversineKmSafe(lat1, lng1, lat2, lng2) {
    var R = 6371;
    var dLat = (lat2 - lat1) * Math.PI / 180;
    var dLng = (lng2 - lng1) * Math.PI / 180;
    var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) + Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) * Math.sin(dLng / 2) * Math.sin(dLng / 2);
    return 2 * R * Math.asin(Math.min(1, Math.sqrt(a)));
  }

  function cmpDistanceKmProp(propA, propB) {
    var da = toNum(propA) != null ? toNum(propA) : Infinity;
    var db = toNum(propB) != null ? toNum(propB) : Infinity;
    return da - db;
  }

  global.WorkshopBookingGeo = {
    toNum: toNum,
    isValidCoord: isValidCoord,
    haversineKm: haversineKm,
    parseCoord: parseCoord,
    firstCoord: firstCoord,
    haversineKmSafe: haversineKmSafe,
    cmpDistanceKmProp: cmpDistanceKmProp
  };
})(typeof window !== 'undefined' ? window : this);
